import { render, staticRenderFns } from "./ratings_display.vue?vue&type=template&id=03d96444&scoped=true&"
import script from "./ratings_display.vue?vue&type=script&lang=js&"
export * from "./ratings_display.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d96444",
  null
  
)

export default component.exports